export const testIgnoreUrls = [
    "/work/history/commute/my/list",
    "/users/",
    "/grades/list",
    "/groups",
    "/employees/",
    // "/employees/role",
    "/companies/",
    // "/companies/my",
    "/constants/koicaNationalCodes",
    "/employees",
    "/parts",
    // "/employees/roleType?type=1"
]